import React from 'react';
import { getSubCategoryId, phone_number_no_spaces, so_str } from '../../../utils/DictionaryManagementUtils';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import SearchContactFP from '../FullPagesComponents/Services/Recipient/SearchContactFP';
import NoResultsContactFP from '../FullPagesComponents/Services/Recipient/NoResultsContactFP';

const SearchResultsDF = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { recipient } = globJSON.configurations.services[subCategoryId];

  //= =====================================================================

  return (
    <SimulatorsViewerArrangement
      simPlatform={simPlatform}
    >
      <SearchContactFP
        globJSON={globJSON}
        selectedScreen={selectedScreen}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
        subCategoryId={subCategoryId}
        headlineText={recipient.select_contact_title}
        text={so_str}
      />
      <NoResultsContactFP
        globJSON={globJSON}
        selectedScreen={selectedScreen}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
        subCategoryId={subCategoryId}
        headlineText={recipient.select_contact_title}
        text={phone_number_no_spaces}
      />
      <NoResultsContactFP
        globJSON={globJSON}
        selectedScreen={selectedScreen}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
        subCategoryId={subCategoryId}
        headlineText={recipient.select_contact_title}
        text={so_str}
        noResultsImage
      />
    </SimulatorsViewerArrangement>
  );
};
export default SearchResultsDF;
